import styled from "styled-components"

const BouncingDotsLoader = props => {
  const { color, width } = props
  return (
    <Wrap className="bouncing-dots bouncing-loader" color={color}>
      <div></div>
      <div></div>
      <div></div>
    </Wrap>
  )
}

const Wrap: any = styled.div`
  &.bouncing-loader {
    display: flex;
    justify-content: center;
    > div {
      width: 8px;
      height: 8px;
      margin: 3px 3px;
      border-radius: 50%;
      background-color: ${(props: any) =>
        props?.color ? props?.color : "#000"};
      opacity: 1;
      animation: bouncing-loader 0.6s infinite alternate;
    }
    > div:nth-child(2) {
      animation-delay: 0.2s;
    }
    > div:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
  @keyframes bouncing-loader {
    to {
      opacity: 0.2;
    }
  }
`
export default BouncingDotsLoader
